import React from 'react';
import PropTypes from 'prop-types';
import {BeatLoader} from "react-spinners";
import {FormattedMessage} from "react-intl";

import {Grid} from "@mui/material";

import HistoryFeedButton from "./HistoryFeedButton";

import {grayColor, primaryColor} from "assets/jss/main";

FeedImportInProgress.propTypes = {
    feed: PropTypes.shape({
        id: PropTypes.string.isRequired,
        retailer: PropTypes.shape({
            id: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};

function FeedImportInProgress({feed}) {
    return (
        <Grid container justifyContent={"flex-end"}>
            <Grid
                item
                xs={6}
                 sx={{
                     fontSize: "16px",
                     color: grayColor,
                 }}
            >
                <FormattedMessage id={"feed.list.table.importInProgress"}/>
            </Grid>
            <Grid item xs={3}>
                <BeatLoader
                    sizeUnit={"px"}
                    size={8}
                    color={primaryColor}
                    loading={true}
                />
            </Grid>
            <Grid item xs={3}>
                <HistoryFeedButton feed={feed} />
            </Grid>
        </Grid>
    );
}

export default FeedImportInProgress;
